const routerOptions = {
    cancellationsForm: {
        path: '/widerrufsformular',
        name: 'cancellationsform',
        component: () => import(/* webpackChunkName: "cancellation" */ '../components/customer/cancellations/CancellationForm'),
        meta: {
            metaInfoProvider: true,
            resource: '*/order-process',
            priority: 1,
        },
    },
    cancellationsConfirmation: {
        path: '/widerruf-abschluss',
        name: 'cancellationsconfirmation',
        component: () => import(/* webpackChunkName: "cancellation" */ '../components/customer/cancellations/CancellationConfirmation'),
        meta: {
            metaInfoProvider: true,
            resource: '*/order-process',
            priority: 1,
        },
    },
};

export default routerOptions;
